export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },  
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Error.vue`
    )
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Login.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/call/realTimeCall',
    meta: { breadcrumb: true },
    name: 'components/realTimeCall',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/call/RealTimeCall.vue`
    )
  },  
  {
    path: '/call/runningDrivers',
    meta: { breadcrumb: true },
    name: 'components/runningDrivers',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/call/RunningDrivers.vue`
    )
  },
  {
    path: '/call/runningBanBanCalls',
    meta: { breadcrumb: true },
    name: 'components/runningBanBanCalls',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/call/RunningBanBanCalls.vue`
        )
  },
  {
    path: '/call/runningBanBanCalls/:id?',
    meta: { breadcrumb: true },
    name: 'components/runningBanBanCallDetail',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/call/RunningBanBanCallDetail.vue`
        )
  },
  {
    path: '/member/passengerMember',
    meta: { breadcrumb: true },
    name: 'components/passengerMember',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/member/PassengerMember.vue`
    )
  },
  {
    path: '/member/passengerMemberDetail/:id?',
    meta: { breadcrumb: true },
    name: 'components/passengerMemberDetail',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/member/PassengerMemberDetail.vue`
    )
  },
  {
    path: '/member/driverMember',
    meta: { breadcrumb: true },
    name: 'components/driverMember',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/member/DriverMember.vue`
    )
  },
  {
    path: '/member/driverMemberDetail/:id?',
    meta: { breadcrumb: true },
    name: 'components/driverMemberDetail',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/member/DriverMemberDetail.vue`
    )
  },
  {
    path: '/report/passengerReport',
    meta: { breadcrumb: true },
    name: 'components/passengerReport',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/report/PassengerReport.vue`
    )
  },
  {
    path: '/usage/passengerUsageHistory',
    meta: { breadcrumb: true },
    name: 'components/passengerUsageHistory',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/usage/PassengerUsageHistory.vue`
    )
  },
  {
    path: '/usage/passengerUsageHistory/:id?',
    meta: { breadcrumb: true },
    name: 'components/passengerUsageHistoryDetail',
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/usage/PassengerUsageHistoryDetail.vue`
        )
  },
  {
    path: '/usage/passengerUsageProblemHistory',
    meta: { breadcrumb: true },
    name: 'components/passengerUsageProblemHistory',
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/usage/PassengerUsageProblemHistory.vue`
        )
  },
  {
    path: '/usage/driverUsageHistory',
    meta: { breadcrumb: true },
    name: 'components/driverUsageHistory',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/usage/DriverUsageHistory.vue`
    )
  },
  {
    path: '/usage/driverUsageHistory/:id?',
    meta: { breadcrumb: true },
    name: 'components/driverUsageHistoryDetail',
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/usage/DriverUsageHistoryDetail.vue`
        )
  },
  {
    path: '/screening',
    meta: { breadcrumb: true },
    name: 'Screening',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/screening/Screening.vue`
    )
  },  
  {
    path: '/payment/passengerPayment',
    meta: { breadcrumb: true },
    name: 'components/passengerPayment',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/payment/PassengerPayment.vue`
    )
  },
  {
    path: '/coupon',
    meta: { breadcrumb: true },
    name: 'Coupon',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/coupon/Coupon.vue`
    ),
    beforeEnter: function(to, from, next) {
      if(localStorage.role !== 'ROOT') {
        next('/403');
      } else {
        next();
      }
    }
  },
  {
    path: '/coupon/couponHistories/:id?',
    meta: { breadcrumb: true },
    name: 'components/couponHistories',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/coupon/CouponHistories.vue`
    ),
    beforeEnter: function(to, from, next) {
      if(localStorage.role !== 'ROOT') {
        next('/403');
      } else {
        next();
      }
    }
  },
  // {
  //   path: '/promotionCode',
  //   meta: { breadcrumb: true },
  //   name: 'PromotionCode',
  //   props: (route) => ({ type: route.query.type }),
  //   component: () => import(
  //       /* webpackChunkName: "routes" */
  //       /* webpackMode: "lazy-once" */
  //       `@/pages/promotionCode/PromotionCode.vue`
  //   ),
  //   beforeEnter: function(to, from, next) {
  //     if(localStorage.role !== 'ROOT') {
  //       next('/403');
  //     } else {
  //       next();
  //     }
  //   }
  // },
  // {
  //   path: '/promotionCode/promotionCodeHistories/:id?',
  //   meta: { breadcrumb: true },
  //   name: 'components/promotionCodeHistories',
  //   component: () => import(
  //       /* webpackChunkName: "routes" */
  //       /* webpackMode: "lazy-once" */
  //       `@/pages/promotionCode/PromotionCodeHistories.vue`
  //       ),
  //   beforeEnter: function(to, from, next) {
  //     if(localStorage.role !== 'ROOT') {
  //       next('/403');
  //     } else {
  //       next();
  //     }
  //   }
  // },
  {
    path: '/passengerSettlement',
    meta: { breadcrumb: true },
    name: 'PassengerSettlement',
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/settlement/PassengerSettlement.vue`
        )
  },
  {
    path: '/settlement',
    meta: { breadcrumb: true },
    name: 'components/settlement',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/settlement/Settlement.vue`
      )
  },
  {
    path: '/settlementDetails',
    meta: { breadcrumb: true },
    name: 'components/settlementDetails',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/settlement/SettlementDetails.vue`
    )
  },
  {
    path: '/appPush',
    meta: { breadcrumb: true },
    name: 'AppPush',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/pages/appPush/AppPush.vue`
        ),
    beforeEnter: function(to, from, next) {
      if(localStorage.role !== 'ROOT' || localStorage.role !== 'MARKETER') {
        next('/403');
      } else {
        next();
      }
    }
  },
  {
    path: '/voc',
    meta: { breadcrumb: true },
    name: 'Voc',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/voc/Voc.vue`
    )
  },  
  {
    path: '/voc/createVoc',
    meta: { breadcrumb: true },
    name: 'createVoc',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/voc/CreateVOC.vue`
    )
  },  
  {
    path: '/voc/updateVoc/:id?',
    meta: { breadcrumb: true },
    name: 'updateVoc',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/voc/UpdateVOC.vue`
    )
  },  
  {
    path: '/voc/vocDetail/:id?',
    meta: { breadcrumb: true },
    name: 'vocDetail',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/voc/VOCDetail.vue`
    )
  },  
  {
    path: '/sms/sendingSMS',
    meta: { breadcrumb: true },
    name: 'components/sendingSMS',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/sms/SendingSMS.vue`
    )
  },  
  {
    path: '/sms/sendingSMS/:phoneNumber?',
    meta: { breadcrumb: true },
    name: 'components/sendingSMS',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/sms/SendingSMS.vue`
    )
  },
  {
    path: '/sms/SMSList',
    meta: { breadcrumb: true },
    name: 'components/SMSList',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/sms/SMSList.vue`
    )
  },
  {
    path: '/simulation',
    meta: { breadcrumb: true },
    name: 'Simulation',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/simulation/Simulation.vue`
    ),
    beforeEnter: function(to, from, next) {
      if(localStorage.role !== 'ROOT') {
        next('/403');
      } else {
        next();
      }
    }
  },
  {
    path: '/server',
    meta: { breadcrumb: true },
    name: 'Server',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/server/ServerState.vue`
    ),
    beforeEnter: function(to, from, next) {
      if(localStorage.role !== 'ROOT') {
        next('/403');
      } else {
        next();
      }
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/paths.js